import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router";

import publicRoutes from "./modules/common/publicRoutes";
import dashboardRoutes from "./modules/dashboard/dashboardRoutes";
import widgetRoutes from "./modules/widget/widgetRoutes";
import LoadingFallback from "./modules/common/components/LoadingFallback";
import ErrorPage from "./modules/common/components/ErrorPage";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Widget = lazy(() => import("./pages/Widget"));

const router = createBrowserRouter(
  [
    {
      path: "/",
      errorElement: (
        <div style={{ height: "100vh" }}>
          <ErrorPage />
        </div>
      ),
      children: [
        {
          path: process.env.PUBLIC_URL,
          children: [
            { index: true, element: <Navigate to="public/login" /> },
            { path: "public", children: publicRoutes },
            {
              path: "dashboard",
              element: (
                <Suspense fallback={<LoadingFallback containerSx={{ height: "100vh", width: "100vw" }} />}>
                  <Dashboard />
                </Suspense>
              ),
              children: dashboardRoutes,
            },
            {
              path: "widget",
              element: (
                <Suspense fallback={<LoadingFallback containerSx={{ height: "100vh", width: "100vw" }} />}>
                  <Widget />
                </Suspense>
              ),
              children: widgetRoutes,
            },
          ],
        },
      ],
    },
  ],
  {
    basename: process.env.BASE_PATH || "",
  },
);

export default router;
